import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export interface GroupUpdateData {
  name?: string;
  description?: string;
  member_ids?: number[];
  user_ids?: number[];
}

export const useUpdateGroup = () => {
  const queryClient = useQueryClient();

  const updateGroup = async ({
    customerId,
    groupId,
    data
  }: {
    customerId: number;
    groupId: number;
    data: GroupUpdateData;
  }): Promise<GroupUpdateData> => {
    const memberIds = data.member_ids ?? data.user_ids ?? [];

    const payload = {
      name: data.name,
      description: data.description,
      member_ids: Array.from(new Set(memberIds))
    };

    const res = await Axios.patch<GroupUpdateData>(
      `${POST_URL(customerId.toString(), groupId.toString()).updateGroupBo}`,
      payload
    );

    return res.data;
  };

  return useMutation<
    GroupUpdateData,
    AxiosError<BaseError>,
    { customerId: number; groupId: number; data: GroupUpdateData }
  >(updateGroup, {
    onSuccess: (_data, { customerId }) => {
      queryClient.invalidateQueries(['customerGroup', customerId], {
        exact: false
      });
    },
    useErrorBoundary: false
  });
};
